import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { API, useAuth, formatErr } from "@/context/AuthContext";
import { ROLE_LABELS } from "@/lib/permissions";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function AcceptInvite() {
  const { token } = useParams();
  const nav = useNavigate();
  const { refresh } = useAuth();
  const [invite, setInvite] = useState(null);
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    axios.get(`${API}/auth/invite/${token}`)
      .then(r => setInvite(r.data))
      .catch(e => setError(formatErr(e)));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 6) { toast.error("Şifre en az 6 karakter olmalı"); return; }
    if (pw !== pw2) { toast.error("Şifreler eşleşmiyor"); return; }
    setBusy(true);
    try {
      await axios.post(`${API}/auth/accept-invite`, { token, password: pw });
      toast.success("Hesabınız oluşturuldu. Hoş geldiniz!");
      await refresh();
      nav("/");
    } catch (err) { toast.error(formatErr(err)); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="relative hidden lg:block">
        <div className="absolute inset-0 bg-cover bg-center"
             style={{ backgroundImage: "url('/login-bg.jpg')" }} />
        <div className="absolute inset-0 bg-[#1B4776]/90" />
        <div className="relative z-10 h-full flex flex-col p-12">
          <img
            src="/mss-logo.png"
            alt="MSS"
            className="h-auto w-[210px] sm:w-[255px]"
            style={{ filter: "brightness(0) invert(1)" }}
          />
          <div className="mt-auto">
            <div className="h-[3px] w-16 bg-[#95C11F] mb-6" />
            <div className="text-[11px] uppercase tracking-[0.3em] font-bold text-[#95C11F]">
              MSS Taahhüt İnşaat San. Tic. Ltd. Şti.
            </div>
            <h2 className="text-4xl sm:text-5xl font-bold text-white tracking-tight font-heading leading-[1.05] mt-4">
              Ekibe hoş<br />geldiniz.
            </h2>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-center p-6 sm:p-12 bg-slate-50">
        <Card className="w-full max-w-md p-8 rounded-none sm:rounded-sm border-slate-200 shadow-sm">
          <div className="lg:hidden flex justify-center mb-6">
            <img src="/mss-logo.png" alt="MSS" className="h-12 w-auto" />
          </div>

          {error && (
            <div className="text-sm text-red-700 bg-red-50 border border-red-200 p-3">{error}</div>
          )}

          {invite && (
            <>
              <div className="text-xs uppercase tracking-[0.25em] font-bold text-[#8595B4] mb-2">
                Davet
              </div>
              <h1 className="text-3xl font-bold tracking-tight text-[#1B4776] font-heading mb-1">
                Merhaba {invite.name},
              </h1>
              <p className="text-sm text-slate-600 mb-6">
                Hesabınızı oluşturmak için bir şifre belirleyin.
              </p>
              <div className="bg-slate-50 border border-slate-200 p-4 mb-6 space-y-1">
                <div className="text-xs text-slate-500">E-posta</div>
                <div className="font-mono text-sm text-slate-900">{invite.email}</div>
                <div className="text-xs text-slate-500 mt-2">Rol</div>
                <div className="text-sm font-semibold text-slate-900">
                  {ROLE_LABELS[invite.role] || invite.role}
                </div>
              </div>

              <form onSubmit={submit} className="space-y-5">
                <div>
                  <Label className="text-xs uppercase tracking-widest font-bold text-slate-700">Şifre Belirleyin</Label>
                  <Input type="password" required value={pw} data-testid="invite-pw"
                         onChange={(e) => setPw(e.target.value)}
                         className="mt-2 rounded-none sm:rounded-sm focus-visible:ring-[#1B4776]" />
                </div>
                <div>
                  <Label className="text-xs uppercase tracking-widest font-bold text-slate-700">Şifre (Tekrar)</Label>
                  <Input type="password" required value={pw2} data-testid="invite-pw2"
                         onChange={(e) => setPw2(e.target.value)}
                         className="mt-2 rounded-none sm:rounded-sm focus-visible:ring-[#1B4776]" />
                </div>
                <Button type="submit" data-testid="invite-submit" disabled={busy}
                        className="w-full h-11 rounded-none sm:rounded-sm bg-[#1B4776] hover:bg-[#153859] text-white font-bold tracking-wide">
                  {busy ? "Oluşturuluyor..." : "Hesabımı Oluştur"}
                </Button>
              </form>
            </>
          )}
        </Card>
      </div>
    </div>
  );
}
